import { render, staticRenderFns } from "./AcademicProgressCalendar.vue?vue&type=template&id=87c4fbba"
import script from "./AcademicProgressCalendar.vue?vue&type=script&lang=js"
export * from "./AcademicProgressCalendar.vue?vue&type=script&lang=js"
import style0 from "./AcademicProgressCalendar.vue?vue&type=style&index=0&id=87c4fbba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports